exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#lblextra[data-v-5dfc5023]{opacity:0;position:absolute;top:0;left:0;height:0;width:0;z-index:-1}", ""]);

// exports
